import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from './constants';
import withoutNulls from '../api/search/withoutNulls';

export const CURRENT_TASKS_VERSION = 'v1';

const taskConverter = {
  toFirestore(entity: Tasks.Task): firebase.firestore.DocumentData {
    return withoutNulls({ ...entity });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<Tasks.Task>,
    options: firebase.firestore.SnapshotOptions,
  ): Tasks.Task {
    const data = {
      ...snapshot.data(options),
    };
    return data;
  },
};

const getTasksRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.TASKS_COLLECTION)
    .withConverter(taskConverter);
};

export default getTasksRef;
